import React from 'react';
import { useTranslation } from 'react-i18next';

import TrackingLink from './TrackingLink';

type Props = {
  deliveryMethod: string;
  trackingNumber: string;
  classes?: {
    trackingLabel?: string;
    trackingLink?: string;
  };
};

const mappingLabel = {
  ['colis éco']: 'LABEL_ORDER_ID_COLISECO',
  ['colissimo']: 'LABEL_ORDER_ID_COLISSIMO',
  ['Mondial Relay']: 'LABEL_ORDER_ID_MONDIAL_RELAY',
};

export default function TrackingDetails({
  deliveryMethod,
  trackingNumber,
  classes,
}: Props): JSX.Element {
  const { t } = useTranslation('ordersPage');
  const tackingLabel = mappingLabel[deliveryMethod] || '';

  return (
    <>
      {tackingLabel && (
        <span className={classes?.trackingLabel}>{t(tackingLabel)}</span>
      )}
      <TrackingLink
        deliveryMethod={deliveryMethod}
        trackingNumber={trackingNumber}
        className={classes?.trackingLink}
      />
    </>
  );
}
